/**
 *
 * Back To Top (JS)
 *
 * @author Takuto Yanagida @ Space-Time Inc.
 * @version 2020-02-19
 *
 */


(function () {
	const OFFSET_Y = 0;

	const btn = document.getElementById('back-to-top');
	const ph  = document.getElementsByClassName('site-footer-misc')[0];
	if (btn === null || ph === null) return;

	window.ST.onScroll(onScroll);
	window.ST.onResize(onScroll);
	if ('ontouchstart' in window) window.addEventListener('touchmove', onScroll);
	setTimeout(onScroll, 100);

	function onScroll() {
		const btnR = btn.getBoundingClientRect();
		const btnH = (btnR.bottom - btnR.top);

		const viewBottomY = window.innerHeight + OFFSET_Y - btnH;
		const footerTopY  = ph.getBoundingClientRect().top;

		if (viewBottomY > footerTopY) {
			btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
			btn.classList.remove('fixed');
		} else {
			btn.style.transform = '';
			btn.classList.add('fixed');
		}

		if (window.pageYOffset > window.innerHeight / 3) {
			btn.classList.remove('hidden');
		} else {
			btn.classList.add('hidden');
		}
	}
})();
